import AWS from 'aws-sdk'
import axios from 'axios';

export const handleNavigate = (navigate, routes) => {

  navigate(routes)
}
export const bucketName = 'svastivideos';
export const bucketRegion = 'ap-south-1';
export const s3 = new AWS.S3({
  apiVersion: '2006-03-01',
  params: { Bucket: bucketName }
});


export function formatDate(dateString) {
  let dateParts = dateString?.split("-");
  let year = dateParts?.[0];
  let month = dateParts?.[1];
  let day = dateParts?.[2];

  let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  let monthName = monthNames[parseInt(month) - 1];

  return `${day}-${monthName}-${year}`;
}


export const fetchData = () => {
  const storedCustomerId = sessionStorage.getItem("SvastiUserID");
const customerId = JSON.parse(storedCustomerId);
  return fetch('https://microservices.svasti.in/CustomerFacingService/RetrieveCustomerInformation', {
    method: 'POST',
    headers: {
      'clientId': 'CustomerFacingService',
      'environment': 'dev',
      'X-API-KEY': process.env.REACT_APP_API_KEY,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      descriptor: 'customerinformation',
      data: [
        {
          customerNumber: customerId,
        }
      ]
    })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      throw error;
    });
};

export const DEMAND_GEN_URL = "https://microservices.svasti.in/DemandGenerationService/generateDemand";
const headers = {
  'X-API-KEY': process.env.REACT_APP_DEMAND_GEN_API_KEY,
  'Content-Type': 'application/json'
};

export const save_demand = async (data) => {
  const body = {
    "data": data
  };

  try {
    const response = await (axios.post(DEMAND_GEN_URL, body,{headers}));
    const result = await response.data;
    return result.data;
  }
  catch (error) {
    console.log("Error while saving data");
    return {
      "data": {
        "NewUpiPaymentId": 'Error while saving data'
      }
    };
  
  }
}

export const formatIndianCurrency = (amount) => {

  if (isNaN(amount)) {
    return "Invalid amount";
  }
  const options = {
    style: 'currency',
    currency: 'INR'
  };
  return amount.toLocaleString('en-IN', options);
}

export const getCurrentDateTime = () => {
  const now = new Date();
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric"
  };
  const formattedDate = now.toLocaleDateString("en-US", options);
  const parts = formattedDate.split(' ');
  const date = `${parts[1]}-${parts[0]}-${parts[2]}`
  return date.replace(',', '');
};

export const getAccountStatement = async () => {
  const storedCustomerId = sessionStorage.getItem("SvastiUserID");
  const customerId = JSON.parse(storedCustomerId);
  const BASE_URL = 'https://microservices.svasti.in/CustomerFacingService';
   const apiKey = process.env.REACT_APP_API_KEY
  try {
    const response = await axios({
      method: 'POST',
      url: `${BASE_URL}/StatementofAccount`,
      headers: {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
      },
      data: {
        data: [
          {
            customerNumber: customerId,
          },
        ],
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching statement of account:', error);
    throw error;
  }
}

export const onLogout = () => {

}

export const formatCurrentDate = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};


export const customerInfoHandler = (customerInfo) => {
  const groupName = customerInfo?.GroupDetails?.Name;
  const groupNumber = customerInfo?.GroupDetails?.Number;
  const memberCount = customerInfo?.GroupDetails?.Customers?.length;
  const dueList = customerInfo?.GroupDetails?.Customers?.filter(el => el.LoanHealth !== "Overdue");
  const overdueList = customerInfo?.GroupDetails?.Customers?.filter(el => el.LoanHealth === "Overdue");
  const overdueMember = overdueList?.length;
  const healthStatus = overdueList?.length > 0 ? "Overdue" : "Regular";
  const dueDate=customerInfo?.GroupDetails?.Customers[0]?.NextInstalmentDetails?.DueDate;
  // alert(dueDate)
  let overdueAmount = 0;
  for (let i = 0; i < overdueList?.length; i++) {
      overdueAmount += overdueList[i]?.OverdueAmount;
  }

  let totalDueAmount = 0;
  let breakup=[]
  for (let i = 0; i < dueList?.length; i++) {
    breakup.push({
      "customerNumber": dueList[i].Number,
      "amount": dueList[i]?.NextInstalmentDetails?.AmountDue,
      "collectionDemandId":dueList[i]?.NextInstalmentDetails?.CollectionDemandId
  })

    totalDueAmount += dueList[i]?.NextInstalmentDetails?.AmountDue;
  }
  

  return { groupName, groupNumber, memberCount, overdueMember, healthStatus, overdueAmount,totalDueAmount,dueDate,breakup };
}


export function getLoanDisbursementDetails(data) {
  // Access the first loan entry in the data array
  const loanData = data;

  // Extract necessary information
  const loanAmount = loanData.Summary.LoanSchemePrincipal;
  const disbursementDate = formatDate(loanData.Summary.LoanDateofDisbursement)

  // Create a new row object with the desired format
  const loanDisbursedRow = {
    Date: disbursementDate,
    Description: "Loan Disbursed",
    Amount: loanAmount,
    Status: "Disbursed"
  };

  return loanDisbursedRow;
}

export function formatCustomDate(isoString) {
  const date = new Date(isoString);
  
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}-${month}-${year} ${hours}:${minutes}`;
}

// Example usage:
const isoDate = new Date().toISOString();
console.log(formatCustomDate(isoDate)); // Output: "17-02-2025 08:02"


const LOGGING_API_URL = "https://microservices.svasti.in/CustomerFacingService/Log";
const IP_API_URL = "https://api64.ipify.org?format=json"; // Fetches the user's public IP
const API_KEY = process.env.REACT_APP_API_KEY

export const saveLogEvent = async (
  {logLevel,
  statusCode,
  status,
  customerNumber,
  message,
  payload}
) => {
  try {
    // Fetch user's IP
    const ipResponse = await axios.get(IP_API_URL);
    const userIP = ipResponse.data.ip;
    const storedCustomerId = sessionStorage.getItem("SvastiUserID");
    const customerId = JSON.parse(storedCustomerId);

    // Prepare log data
    const logData = {
      data: [
        {
          logLevel,
          statusCode,
          status,
          message: {
            customerNumber: customerId || customerNumber|| "N/A",
            ...message,
            source: "MCRO",
              timestamp: formatCustomDate(new Date().toISOString()),
            payload:{
              ...payload,
              sessionId:sessionStorage.getItem("sessionId"),
              timestamp: formatCustomDate(new Date().toISOString()),
              requesterIPAddress: userIP || "N/A",
              customerNumber: customerId || customerNumber|| "N/A",
            },
          },
        },
      ],
    };

    // Send log event with API Key
    const response = await axios.post(LOGGING_API_URL, logData, {
      headers: {
        "X-API-KEY": API_KEY,
        "Content-Type": "application/json",
      },
    });

  } catch (error) {
    console.error("Error fetching IP or saving log:", error);
  }
};